import React, { useEffect, useState } from 'react'
import { Box, withStyles } from '@material-ui/core'
import { CoreNavigation, CoreIconButton } from 'src/components/core'
import Logo from 'src/components/logo/index'
import { Account, UpgradeButton } from '../index'
import { Icon } from '@iconify/react'
import { llmChatDrawerOpen } from 'src/reducers/llm/action'
import { useDispatch, useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import styles from './styles'
import { usePageController, getTabList } from '../index'
import { useHistory } from 'react-router-dom'

const MainToolBar = props => {
  const { classes } = props
  const history = useHistory()
  const dispatch = useDispatch()

  const { pageController, updatePageController } = usePageController()

  const tabList = getTabList(pageController, history)

  useEffect(() => {
    updatePageController()
  }, [window.location.pathname])

  return (
    <>
      <div className={classes.toolbarFlexStyle}>
        {!isMobile && <Logo />}
        {isMobile && pageController.chat && (
          <CoreIconButton
            color="secondary"
            variant="text"
            size="small"
            onClick={() => dispatch(llmChatDrawerOpen())}
          >
            <Icon icon="ic:round-menu" />
          </CoreIconButton>
        )}
        <CoreNavigation
          tabList={tabList}
          color="secondary"
          backgroundColor="secondary"
          size="medium"
          loading={false}
        />
      </div>

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {pageController.showUpgrade && <UpgradeButton />}
        <Account dispatch={dispatch} />
      </Box>
    </>
  )
}

export default withStyles(styles)(MainToolBar)
